import { Button, Intent, Tooltip } from "@blueprintjs/core"
import { __ } from "src/libs/utilities"
import { HISTORY_TYPE, IHistoryStep, ILandingSection, ILandingSectionTitle, SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { useLandingStore } from "src/modules/pe-landing-module/data/store"
import descriptionIcon from "../../../../../assets/img/description-1.svg"
import makeupIcon from "../../../../../assets/img/makeup.svg"
import titleIcon from "../../../../../assets/img/title-1.svg"
import updateSection from "../../utils/updateSection"

/* Protopia Ecosystem component */
export interface ITitleEditFormProps {
   section: ILandingSection
}
const TitleEditForm = (props: ITitleEditFormProps): JSX.Element => {
    const onEditTitle = () => {
        useLandingStore.setState({ 
            curEditModal: { 
                sectionId: props.section?.id, 
                currentEditType: SELECT_TYPE.TITLE,
            }            
        })
    }
    const onEditDescr = () => {
        useLandingStore.setState({ 
            curEditModal: { 
                sectionId: props.section?.id, 
                currentEditType: SELECT_TYPE.DESCRIPTION,
            }            
        })
    }
    const onMakeup = () => {
        useLandingStore.setState({ 
            isMakeupDrawerOpen: true,
            makeupType: SELECT_TYPE.TITLE
        })
    }
    const onDelete = () => { 
        const newVal: ILandingSection = {
            ...props.section,
            title: {} as ILandingSectionTitle
        }
        const step: IHistoryStep = {
            data: newVal,
            prevData: props.section,
            type: HISTORY_TYPE.SECTION,
            title: "Delete section title"
        }
        updateSection(newVal, step)
    }
    return <div className='landing-data-edit-form-cont '>
        <div className="landing-data-content-container  text-light small">
            <Tooltip
                intent={Intent.PRIMARY}
                position="top-left"
                content={__("Edit title")}
            >
                <Button 
                    intent={Intent.NONE}  
                    className={`p-1`} 
                    onClick={ onEditTitle }
                > 
                    <img
                        src={ titleIcon }
                        height={ 12 }
                        className="svg-force-contrast landing-icon my-2"
                        style={{
                            height: 12,
                            opacity: 1,
                        }}
                        alt=""
                    /> 
                </Button> 
            </Tooltip>
            <Tooltip
                intent={Intent.PRIMARY}
                position="top-left"
                content={__("Edit description")}
            >
                <Button   
                    className={`p-1`} 
                    intent={Intent.NONE}
                    onClick={ onEditDescr }
                > 
                    <img
                        src={ descriptionIcon }
                        height={ 12 }
                        className="svg-force-contrast landing-icon my-2"
                        style={{
                            height: 12,
                            opacity: 1,
                        }}
                        alt=""
                    /> 
                </Button> 
            </Tooltip>
            <Tooltip
                intent={Intent.PRIMARY}
                position="top-left"
                content={__("Makeup")}
            >
                <Button  
                    className={` p-1`}
                    intent={Intent.WARNING}
                    onClick={ onMakeup }
                > 
                    <img
                        src={ makeupIcon }
                        height={ 12 }
                        className="svg-force-contrast landing-icon my-2"
                        style={{
                            height: 12,
                            opacity: 1,
                        }}
                        alt=""
                    />
                </Button> 
            </Tooltip> 
            <Tooltip
                intent={Intent.PRIMARY}
                position="top-left"
                content={__("Delete")}
            >
                <Button icon="trash" className="p-2 ml-1 " intent={Intent.DANGER} onClick={onDelete}  /> 
            
            </Tooltip>
        </div>
    </div>
}
export default TitleEditForm